import { PaymentMethod } from '@/enums/PaymentMethod';
import { Globals } from '@/modules/Globals';

/**
 * Methods offerable when CHARGING (ModalPay). Callers apply their own runtime
 * filters on top (hiddenMethods, Club gated on clubBalanceEnabled).
 */
export const CHARGEABLE_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.Cash,
  PaymentMethod.Card,
  PaymentMethod.BankTransfer,
  PaymentMethod.Online,
  PaymentMethod.QR,
  PaymentMethod.Invitation,
  PaymentMethod.Employee,
  PaymentMethod.CustomerAccount,
  PaymentMethod.Club,
];

/**
 * Methods a caja movement / payment can be REASSIGNED to ("Cambiar medio de
 * pago"). CustomerAccount and Club are excluded because both are
 * ledger-backed: the API rejects Club in either direction
 * (v2.payments.service changePaymentMethod / caja-movement.service guards),
 * and reassigning to CustomerAccount would bypass the cuenta-cliente ledger
 * debit.
 */
export const REASSIGNABLE_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.Cash,
  PaymentMethod.Card,
  PaymentMethod.BankTransfer,
  PaymentMethod.Online,
  PaymentMethod.QR,
  PaymentMethod.Invitation,
  PaymentMethod.Employee,
];

export interface IPaymentMethodOption {
  value: PaymentMethod;
  text: string;
}

/**
 * Maps methods to `{ value, text }` options using the single label source
 * (`Globals.shortPaymentMethods`), preserving the given list's order.
 */
export function paymentMethodOptions(
  methods: PaymentMethod[]
): IPaymentMethodOption[] {
  return methods
    .map((id) => {
      const entry = Globals.shortPaymentMethods.find((m) => m.id === id);
      return entry ? { value: entry.id, text: entry.title } : null;
    })
    .filter((option): option is IPaymentMethodOption => option !== null);
}
